import ky, { type Options } from "ky";

export function createApiClient({ baseUrl, options }: { baseUrl: string; options?: Options }) {
  const client = ky.create({
    prefixUrl: baseUrl,
    ...options,
  });
  return client;
}

export type ApiClient = ReturnType<typeof createApiClient>;
